import { getRegisterStatusNum, getRegisterList, getSchedulingTime, doctorSchedulingList } from '@/api/register'
import { getTimeQuantumList, scheduleAdd, getTimeRule, delScheduling, scheduleInfo, scheduleEdit, scheduleList, automaticScheduling } from '@/api/schedule'
import { registerAdd, registerCancel,registerRefund } from '@/api/registration'

class registerDTO {
    /**
     * 查询医生排班 列表
     */
    static getRegisterList(params) {
        return new Promise((resolve, reject) => {
            doctorSchedulingList(params).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 查询挂号单数量
     */
    static getRegisterStatusNum(params) {
        return new Promise((resolve, reject) => {
            getRegisterStatusNum(params).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 查询挂号列表
     */
    static getRegisterList(params) {
        return new Promise((resolve, reject) => {
            getRegisterList(params).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 查询医生班次
     */
    static getSchedulingTime(params) {
        return new Promise((resolve, reject) => {
            getSchedulingTime(params).then(res => {
                resolve(res)
            })
        })
    }


    /**
     * 获取排班下时间段
     */
    static getTimeQuantumList(params) {
        return new Promise((resolve, reject) => {
            getTimeQuantumList(params).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 新增挂号
     */
    static registerAdd(params) {
        return new Promise((resolve, reject) => {
            registerAdd(params).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 未支付取消挂号
     */
    static registerCancel(params) {
        return new Promise((resolve, reject) => {
            registerCancel(params).then(res => {
                resolve(res)
            })
        })
    }
    
    /**
     * 已支付取消挂号
     */
    static registerRefund(params) {
        return new Promise((resolve, reject) => {
            registerRefund(params).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 查询医生排班 列表
     */
    static doctorSchedulingList(params) {
        return new Promise((resolve, reject) => {
            doctorSchedulingList(params).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 新增排班
     */
    static scheduleAdd(params){
        return new Promise((resolve, reject) => {
            scheduleAdd(params).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 修改排班信息
     */
    static scheduleEdit(params){
        return new Promise((resolve, reject) => {
            scheduleEdit(params).then(res => {
                resolve(res)
            })
        })
    }
    /**
     * 获取排班列表
     */
    static scheduleList(params){
        return new Promise((resolve, reject) => {
            scheduleList(params).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 获取排班详情
     */
    static scheduleInfo(schedulingItemId){
        return new Promise((resolve, reject) => {
            scheduleInfo(schedulingItemId).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 删除排班
     */
    static delScheduling(params){
        return new Promise((resolve, reject) => {
            delScheduling(params).then(res => {
                resolve(res)
            })
        })
    }
    
    /**
     * 获取排班规则
     */
    static getTimeRule(params){
        return new Promise((resolve, reject) => {
            getTimeRule(params).then(res => {
                resolve(res)
            })
        })
    }
    /**
     * 添加自动排班
     */
    static automaticScheduling(params){
        return new Promise((resolve, reject) => {
            automaticScheduling(params).then(res => {
                resolve(res)
            })
        })
    }


}

export { registerDTO }